import humanReadableDate from '@utilities/humanReadableDate';
import _uniqueId from 'lodash/uniqueId';

// Use symbols for private attributes
const _properties = Symbol('properties');

export default class Model {
    /**
     * The Model class constructor.
     */
    constructor (data = null, symbol = null) {
        this._id = (data || {}).id || null;

        // This is required to create a unique identifier for certain props that don't parse
        // the getter values when defining the model, causing pass-by-reference duplicates.
        this._key = Number(_uniqueId());

        this._symbol = symbol || _properties;

        this[this._symbol] = data || {};
    }

    /**
     * Getter for the model ID.
     *
     * @return {Number}
     */
    get id () {
        return this[this._symbol].id;
    }

    /**
     * Getter for the creation date object.
     *
     * @return {String}
     */
    get createdAt () {
        return new Date(this[this._symbol].created_at);
    }

    /**
     * Getter for the update date object.
     *
     * @return {String}
     */
    get updatedAt () {
        return new Date(this[this._symbol].updated_at);
    }

    /**
     * Getter for the relative human readable creation timestamp.
     *
     * @return {String}
     */
    get relativeCreatedAt () {
        return humanReadableDate(this[this._symbol].created_at);
    }

    /**
     * Getter for the relative human readable update timestamp.
     *
     * @return {String}
     */
    get relativeUpdatedAt () {
        return humanReadableDate(this[this._symbol].updated_at);
    }

    /**
     * Get the original object.
     *
     * @return {Object}
     */
    getObject () {
        return this[this._symbol];
    }
}
